module.exports = __webpack_public_path__ + "static/media/ic_statements.d199e295.png";